import { Component, Input } from '@angular/core';
import { SolIcon } from '@sol/icons';
import { AbstractComponent } from '../../abstract.component';
import { SolIconShape, SolIconSize, SolIconStyle } from '../../../models/core/sol-icon-style';
import { SolSpinnerComponent } from '../sol-spinner/sol-spinner.component';

@Component({
  selector: 'sol-icon',
  templateUrl: './sol-icon.component.html',
  imports: [SolSpinnerComponent],
  host: { '[class]': 'hostClass$()' },
})
export class SolIconComponent extends AbstractComponent<SolIconStyle> {
  // Computed
  protected readonly href$ = this.computeByRef(state => state.href);
  protected readonly isSpinner$ = this.computeByRef(state => state.isSpinner);
  protected readonly hostClass$ = this.computeByRef(state => state.hostClass);

  constructor() {
    super(SolIconStyle.of());
  }

  @Input()
  public set name(name: SolIcon | undefined) {
    this.update(state => state.withName(name));
  }

  @Input()
  public set size(size: SolIconSize | undefined) {
    this.update(state => state.withSize(size));
  }

  @Input()
  public set shape(shape: SolIconShape | undefined) {
    this.update(state => state.withShape(shape));
  }
}
